
<template>
  <el-form-item :label="params.label" class="watsonDaterange">
    <el-date-picker
      class="w150"
      size="small"
      v-model="dataRange"
      :editable="false"
      :clearable="false"
      type="daterange"
      popper-class="custom_dataRange_picker"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-dataRange',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      dataRange: this.setDateRange(this.params),
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.cuttentTime = minDate.getTime()
          if (maxDate) {
            this.cuttentTime = ''
          }
        },
        disabledDate: (time) => {
          if (this.cuttentTime !== '') {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.cuttentTime - one
            const maxTime = this.cuttentTime + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }

    }
  },
  created() {},
  methods: {
    setDateRange(params) {
      const today = new Date();
      let range;
      let startDate, endDate;
      if (params.id === '120-s-5') {
        // 使用中间变量设置开始和结束日期
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 2);
        endDate = new Date(today);
        range = [startDate, endDate];
        params.start = startDate; // 赋值给params.start
        params.end = endDate;     // 赋值给params.end
      } else {
        range = params.start && params.end ? [new Date(params.start), new Date(params.end)] : null;
      }
      return range;
    },
    reset() {
      if (this.params.dValue) {
        this.dataRange = this.setDateRange(this.params)
      } else {
        this.dataRange = this.params.dValue
      }
    },
    getValue() {
      if (this.dataRange && this.dataRange.length) {
        if (this.params.key !== 'time') {
          return {
            [this.params.key + 'StartTime']: dateFormat(this.dataRange[0], 'yyyy-MM-dd 00:00:00'),
            [this.params.key + 'EndTime']: dateFormat(this.dataRange[1], 'yyyy-MM-dd 23:59:59')
          }
        } else {
          return {
            startTime: dateFormat(this.dataRange[0], 'yyyy-MM-dd 00:00:00'),
            endTime: dateFormat(this.dataRange[1], 'yyyy-MM-dd 23:59:59')
          }
        }
      }
      return undefined
    }
  },
  watch: {
    dataRange(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      if (nv) {
        cp.start = dateFormat(nv[0], 'yyyy-MM-dd')
        cp.end = dateFormat(nv[1], 'yyyy-MM-dd')
      } else {
        cp.start = undefined
        cp.end = undefined
      }
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
.custom_dataRange_picker{
  width: 17%;
  /* 隐藏右边日期面板 */
  .el-picker-panel__content.el-date-range-picker__content.is-right .el-date-table,
  .el-picker-panel__content.el-date-range-picker__content.is-right
  .el-date-range-picker__header
  div {
    display: none !important;
    height: 800px;
  }
  .el-picker-panel__content.el-date-range-picker__content.is-right
  .el-date-range-picker__header {
    width: 60px;
    top: -331px;
    left: 230px;
  }
  /* 设置整体日期面板的宽度 */
  .el-picker-panel.el-date-range-picker.el-popper {
    width: 322px;
  }

  /* 隐藏中间线段 */
  .el-date-range-picker__content.is-left {
    border-right: none;
  }

  /* 左边日期面板宽度 */
  .el-picker-panel__content {
    width: 63% !important;
  }

  .el-picker-panel__content.el-date-range-picker__content.is-right .el-date-range-picker__header {
    top: -281px;
  }
  .el-date-range-picker__content.is-left {
    height: 270px;
  }
}
</style>
